import React, { useEffect, useRef, useState, } from 'react'
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { BASE_URL } from '../../config/axios';
import { useNavigate } from "react-router-dom";
import Dashboardnavbar from '../../layout/Dashboardnavbar';
import * as XLSX from 'xlsx';
import { Modal } from 'react-bootstrap';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { DownloadOfficeBill } from '../SiteManagement/BulkModals';
import ReactToPrint from 'react-to-print';
import { formatCurrencyIndian, getMonthName, handleErrorToast, sortProjects, ViewRequestStatus, ViewRequestRemarks, ViewDynamicApprovalRemarks, ViewDynamicApprovalStatus, ProgressModal } from '../CustomFunctions';

import { AddwithWhiteCircle, Calender, CircularGrid, DeleteDustbin, DropdownArrow, Location, UpdatePencil, HourGlass, Filter, SearchBig, AddwithBlueCircle, DropdownArrowOption, DownloadIcon, UploadIcon, Attachment, Refresh, Eye, Month, Year, SubCompany } from '../AllSvg';

import usePermission from '../../config/permissions';
import { MonthModern, Monthprefix0, Projects, YearModern } from '../FilterDropdown';
import { formatDate, formattedDateLong, datearray } from '../Date';
import { UploadOfficeRentBulk } from '../SiteManagement/BulkModals';
import OfficeBillingstats from '../StatusBar/OfficeBillingstata';
import { DocumentModel } from '../SiteManagement/ProjectDetailsCrudButtons';
import { AddMultipleOfficeRentBilling } from '../SiteManagement/BulkCRUD';
import { AlertCircle, Building2, ChevronDown, ChevronUp, FileText, Landmark, Loader, Printer, Receipt, ReceiptIndianRupeeIcon, Sparkles, Trash2, Wallet, X } from 'lucide-react';





const AddOfficeBillDetails = ({ getOfficeBill, projectList }) => {
    const [show, setShow] = useState(false);
    const [buffer, setBuffering] = useState(false); //buffering logic

    const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format

    const handleClose = () => {
        setFormData({
            project_id: "null",

            bill_date: "null",

        })
        setErrors({});
        setShow(false);
    };
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        project_id: "null",
        bill_date: "null",

    });


    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["project_id", "bill_date"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };

            if (value) {
                delete updatedErrors[name];
            }


            return updatedErrors;
        });
    };


    // ?  ************** Validation End **************  ! //

    const [loading, setLoading] = useState(false); //loading logic
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            setLoading(true); //loading logic
            try {
                let res = await axios.post(`${BASE_URL}/siteproject/officerent/`, formData);

                if (res.status === 200) {
                    await getOfficeBill();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success("Bill Details Added Successfully");
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };


    return (
        <>

            <button title="Add Office Rent Bill" className="upload-svg" onClick={handleShow}>
                <AddwithWhiteCircle />
                {" "} Office Bill
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton className=" task-Tab-heading font-weight500    font-size-heading ">
                    <Modal.Title>Add Office Rent Bill</Modal.Title>
                </Modal.Header>

                <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="flex-column form-group-selectt">
                                <label htmlFor="project" className="form-labels  font-weight500    font-size-subheading" title="Sub Company">
                                    Project<span className="required">*</span>
                                </label>
                                <br />
                                <select
                                    id="project"
                                    name="project_id"
                                    title="Project "
                                    value={formData.project_id}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.project_id ? "error" : inputState.project_id ? "success" : ""
                                        }`}
                                >
                                    <option value="">Select Project </option>
                                    {projectList.map(project => (<option value={project.id}>{project.site_prcode}-{project.project_short_name}</option>))};
                                </select>




                                {errors.project && (
                                    <span className="error-message font-size-text ">{errors.project}</span>
                                )}
                            </div>


                            <div title="Bill Date" className="flex-column">
                                <label htmlFor="bill_date" className="form-labels font-weight500    announce-date font-weight400  font-size-heading">
                                    Bill Date<span className="required">*</span>
                                </label>
                                <input
                                    id="bill_date"
                                    type="date"
                                    name="bill_date"
                                    placeholder="date"
                                    onChange={handleInputChange}
                                    value={formData.bill_date}
                                    max={today}
                                    className={`form-input ${errors.bill_date ? "error" : inputState.bill_date ? "success" : ""
                                        }`}
                                />
                                {errors.bill_date && (
                                    <span className="error-message font-size-text ">{errors.bill_date}</span>
                                )}
                            </div>




                            <div className="button-models">
                                <button className="model-button   font-weight500  model-button-cancel " type="button" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    //   type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleFormSubmit}
                                    disabled={loading}
                                >
                                    Add
                                </button>
                            </div>
                            <p className="error-message font-size-text">
                                {isSubmitted && Object.keys(errors).length > 0 && (
                                    Object.keys(errors).length > 5 ? (
                                        <h5 className="text-center">Please fill all mandatory fields!</h5>
                                    ) : (

                                        <h6 className="text-center">
                                            {Object.keys(errors).map((field) =>
                                                field.charAt(0).toUpperCase() + field.slice(1)
                                            ).join(', ') + ' are required!'}
                                        </h6>
                                    )
                                )}
                            </p>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};
const DeleteOfficeRentBill = ({ i, getOfficeBill }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        setShowProgressModal(true);
        setLoading(true);
        setUploadProgress(0);

        const loadingToastId = toast.loading("Loading: Please wait...");

        let progress = 0;
        const interval = setInterval(() => {
            progress += 10;
            if (progress >= 100) {
                progress = 100;
                clearInterval(interval);
            }
            setUploadProgress(progress);
        }, 100);

        try {
            let res = await axios.delete(`${BASE_URL}/siteproject/officerentbillingupdate/${i.id}/`);

            if (res.status === 200) {
                await getOfficeBill();
                toast.dismiss(loadingToastId);
                toast.success("Data deleted successfully!");
                setShow(false);
            } else {
                alert(res);
            }
        } catch (err) {
            clearInterval(interval);
            setUploadProgress(0);
            handleErrorToast(err);
        } finally {
            clearInterval(interval);
            setTimeout(() => {
                setShowProgressModal(false);
            }, 1500);
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button title="Delete Office Rent Bill" className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075" }} onClick={handleShow}>
                <DeleteDustbin modernButton="true" />
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Delete" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-required-modal" centered>
                    <Modal.Header className="modern-modal-header requirement-modal-header">
                        <div className="header-content">
                            <div className="requirement-header-icon">
                                <Trash2 size={22} />
                            </div>
                            <div>
                                <Modal.Title>Delete Office Billing Detail</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>
                                    This action cannot be undone
                                </p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body requirement-modal-body">
                        <div className="requirement-mode-summary" style={{ marginBottom: '20px' }}>
                            <AlertCircle size={16} />
                            <span>
                                Are you sure you want to delete this office billing record for <strong>{i.project_short_name}</strong>?
                            </span>
                        </div>

                        <div className="submit-buttons" style={{ justifyContent: 'flex-end' }}>
                            <button type="button" className="btn-secondaryy" onClick={handleClose} disabled={loading}>
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn-primaryy"
                                style={{ background: "#dc3545", borderColor: "#dc3545" }}
                                onClick={handleFormSubmitDelete}
                                disabled={loading}
                            >
                                {loading ? <Loader size={18} className="spinning" /> : <Trash2 size={18} />}
                                <span>{loading ? 'Deleting...' : 'Delete'}</span>
                            </button>
                        </div>

                        <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};
const GenerateOfficeBillingDetails = ({ getOfficeBillingDetails, OfficeList, projectList, projectid }) => {
    // console.log(projectList, 'projectid')
    const [show, setShow] = useState(false);

    const { projectID } = usePermission();

    const siteRole = sessionStorage.getItem("sitemanagement_role");
    const handleShow = () => {
        // getVehicle();
        setShow(true);
    }

    const handleClose = (e) => {
        // getVehicle();
        // e.preventDefault();
        setShow(false);
    }




    const [formData, setFormData] = useState({
        month: datearray[1],
        year: datearray[0],
        numberproject: siteRole === "SiteManagement" ? "All" : '',
        project: projectID ? projectID : "",
        date: '',
    });

    const [errors, setErrors] = useState({});
    // !  ************** Validation start **************  ! //
    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "project",
            "date",
        ]
        console.log(formData.month)
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    }

    const validateForm2 = () => {
        const newErrors = {};
        const requiredFields = [

            "date",
        ]
        console.log(formData.month)
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    }









    const monthOptions = [
        { id: 1, name: "January" },
        { id: 2, name: "February" },
        { id: 3, name: "March" },
        { id: 4, name: "April" },
        { id: 5, name: "May" },
        { id: 6, name: "June" },
        { id: 7, name: "July" },
        { id: 8, name: "August" },
        { id: 9, name: "September" },
        { id: 10, name: "October" },
        { id: 11, name: "November" },
        { id: 12, name: "December" }
    ];
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 20; // starting 20 years ago
    const endYear = currentYear + 20; // up to 20 years in the future
    const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);





    const handleInputChange = (e) => {
        const { name, value } = e.target;



        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // ?  ************** Validation End **************  ! //
    const [generateSingleProjectloading, setGenerateSingleProjectLoading] = useState(false);
    const [generateAllProjectloading, setGenerateAllProjectLoading] = useState(false);
    const handleGenerateSingleProject = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setGenerateSingleProjectLoading(true); //loading logic

            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic



            try {
                const ress = await axios.post(
                    `${BASE_URL}/siteproject/generateofficerentbillsbyproject/`,
                    {
                        project_id: formData.project,
                        bill_date: formData.date,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );


                if (ress.status === 200) {
                    await getOfficeBillingDetails();
                    setShow(false);

                } else if (ress.status === 400) {
                    toast.error("Billing for this project and month already exists.")
                    setShow(false);
                } else {

                }
            } catch (err) {
            } finally {
                setGenerateSingleProjectLoading(false); // Ensure loading state is stopped even in case of error //loading logic
                toast.dismiss(loadingToastId);
            }
        }




    };

    const handleGenerateAllProject = async (e) => {
        e.preventDefault();

        if (validateForm2()) {
            setGenerateAllProjectLoading(true); //loading logic

            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic


            try {
                const ress = await axios.post(
                    `${BASE_URL}/siteproject/officerentbillgenerator/`,
                    {
                        project_id: formData.project,
                        bill_date: formData.date,
                        month: new Date(formData.date).getMonth() + 1,
                        year: new Date(formData.date).getFullYear(),
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );


                if (ress.status === 200) {
                    await getOfficeBillingDetails();
                    setShow(false);
                } else if (ress.status === 400) {
                    toast.error("Billing for this project and month already exists.")
                    setShow(false);
                } else {

                }
            } catch (err) {
                handleErrorToast(err);
            } finally {
                setGenerateAllProjectLoading(false); // Ensure loading state is stopped even in case of error //loading logic
                toast.dismiss(loadingToastId);
            }
        }









    };





    // const [generateAllVehicleloading, setGenerateAllVehicleLoading] = useState(false); //loading logic
    // const handleGenerateAllVechicle = async (e) => {
    //     e.preventDefault();
    //     if (validateForm()) {
    //         setGenerateAllVehicleLoading(true); //loading logic

    //         const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

    //         try {
    //             let ress = await axios.post(
    //                 `${BASE_URL}/siteproject/generate-vehicle-bill-by-all-vehicle/`
    //             );

    //             if (ress.status === 200) {
    //                 await getOfficeBillingDetails();

    //             } else {
    //                 alert(ress);
    //             }
    //         } catch (err) {
    //             handleErrorToast(err);
    //         } finally {
    //             setGenerateAllVehicleLoading(false); // Ensure loading state is stopped even in case of error //loading logic
    //             toast.dismiss(loadingToastId);
    //         }
    //     }


    // };



    return (
        <>
            <button title="Generate Office  Bills" className="upload-svg" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <g clip-path="url(#clip0_1415_3177)">
                        <path
                            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
                            fill="white"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_1415_3177">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                {" "} Generate Bills
            </button>

            <Modal show={show}
                onHide={(e) => handleClose(e)}
                dialogClassName="request-leave  width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Generate Bills</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form>
                                {/* {siteRole === "SiteManagement" ? ("") : (<div title="project" className="flex-column form-group-selectt">
                                    <label htmlFor="project" className="form-labels  font-weight500    font-size-subheading">
                                        What to Generate Bill for ?
                                    </label>
                                    <br />
                                    <select
                                        id="numberproject"
                                        name="numberproject"
                                        value={formData.numberproject}
                                        onChange={handleInputChange}
                                        className="form-input form-group-selection"
                                    >
                                        <option value="">Generate Bill for </option>
                                        <option value="single">Single</option>
                                        <option value="All">All</option>
                                    </select>
                                    
                                <div>
                                    {errors.numberproject && (
                                        <span className="error-message font-size-text ">{errors.numberproject}</span>
                                    )}
                                </div>
                        </div>)} */}

                                {

                                    formData.numberproject === "single" && siteRole !== "SiteManagement" &&
                                    <div title="Project" className="flex-column form-group-selectt">
                                        <label htmlFor="project" className="form-labels  font-weight500    font-size-subheading">
                                            Project<span className="required">*</span>
                                        </label>
                                        <br />
                                        <select
                                            type="text"
                                            id="project"
                                            name="project"
                                            placeholder="project"
                                            value={formData.project}
                                            onChange={handleInputChange}
                                            className='form-input form-group-selection'
                                        >

                                            <option value="null">Select a Project</option>
                                            {projectList?.sort((a, b) => a.project_short_name.localeCompare(b.project_short_name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                                <option key={index} value={i.id}>{i.project_short_name}</option>
                                            ))}
                                        </select>

                                        <div className="form-group-selection-arrow">

                                        </div>

                                    </div>
                                }

                                {/* <div title="Month" className="flex-column form-group-selectt">
                                    <label htmlFor="month" className="form-labels  font-weight500    font-size-subheading">
                                        Month<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        type="text"
                                        id="month"
                                        name="month"
                                        placeholder="month"
                                        value={formData.month}
                                        onChange={handleInputChange}
                                        className={`form-input-date form-group-selection `}
                                    >

                                        <option value="">Select a month</option>
                                        {monthOptions.map((month) => (
                                            <option key={month.id} value={month.id}>{month.name}</option>
                                        ))}
                                    </select>
                                    <div className="form-group-selection-arrow">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="25"
                                            fill="currentColor"
                                            className="bi bi-caret-down-fill"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                        </svg>
                                    </div>

                                </div>

                                <div title="Year" className="flex-column form-group-selectt">
                                    <label htmlFor="year" className="form-labels  font-weight500    font-size-subheading">
                                        Year<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        type="text"
                                        id="year"
                                        name="year"
                                        placeholder="year"
                                        value={formData.year}
                                        onChange={handleInputChange}
                                        className={`form-input-date form-group-selection`}
                                    >

                                        <option value="">Select a Year</option>
                                        {years.map((year) => (
                                            <option key={year} value={year}>{year}</option>
                                        ))}
                                    </select>
                                    <div className="form-group-selection-arrow">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="25"
                                            fill="currentColor"
                                            className="bi bi-caret-down-fill"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                        </svg>
                                    </div>

                                </div> */}
                                <div className="flex-column">
                                    <label htmlFor="date" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                        Date<span className="required">*</span>
                                    </label>
                                    <input
                                        id="date"
                                        type="date"
                                        name="date"
                                        onChange={handleInputChange}
                                        value={formData.date}
                                        className={`form-input 
                  
                    `}

                                    //   ${errors.date ? "error" : inputState.date ? "success" : ""
                                    // }
                                    />
                                    {errors.date && (
                                        <span className="error-message font-size-text ">{errors.date}</span>
                                    )}
                                </div>

                                <div>
                                    {formData.numberproject === "single" ? (<>
                                        <button className="model-button  font-weight500  model-button-bill   model-button-leave font-size-heading" title="generateSingleProjectloading" onClick={handleGenerateSingleProject} disabled={generateAllProjectloading} >
                                            {generateSingleProjectloading ? 'Generating...' : 'Generate For Single Project'}
                                        </button>
                                    </>) : (<>
                                        <button className="model-button  font-weight500  model-button-bill   model-button-leave font-size-heading" title="generateAllProjectloading" onClick={handleGenerateAllProject} disabled={generateAllProjectloading} >
                                            {generateAllProjectloading ? 'Generating...' : 'Generate For All Project'}
                                        </button>
                                    </>)}


                                </div>

                                {/* <div>
                                    <button className="model-button  font-weight500 model-button-bill    model-button-leave font-size-heading" title='generateAllVehicleloading' onClick={handleGenerateAllVechicle} disabled={generateAllVehicleloading} >
                                        {generateAllVehicleloading ? 'Generating...' : 'Generate For All Vehicle'}
                                    </button>

                                </div> */}
                                {/* 
                  <div>
                  <GenerateforVehicle vehicleList={vehicleList} />
                  
                  </div> */}



                                <div className="button-models">
                                    <button className="model-button-cancel model-button font-weight500" onClick={(e) => handleClose(e)}>
                                        Cancel
                                    </button>

                                </div>
                            </form>
                        </div></div>
                </Modal.Body >
            </Modal >
        </>




    )
}

const ViewPdfoffice = ({ i, getOfficeBill }) => {
    const [show, setShow] = useState(false);
    const ref = useRef();

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.delete(`${BASE_URL}/siteproject/officerentbillingupdate/${i.id}/`);

            if (res.status === 200) {
                await getOfficeBill();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Data deleted successfully!");
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <style>{`
                .pobill-trigger {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 32px;
                    height: 32px;
                    border-radius: 8px;
                    border: none;
                    background: #00000075;
                    cursor: pointer;
                    transition: opacity 0.15s ease;
                }
                .pobill-trigger:hover {
                    opacity: 0.85;
                }
                .pobill-card {
                    border: 1px solid #e5e7eb;
                    border-radius: 16px;
                    overflow: hidden;
                    background: white;
                }
                .pobill-card-header {
                    background: linear-gradient(180deg, #0f172a 0%, #1e293b 100%) !important;
                    padding: 20px 24px;
                    color: white;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    gap: 10px;
                }
                .pobill-card-header-title {
                    font-size: 17px;
                    font-weight: 700;
                    margin: 0;
                }
                .pobill-card-header-sub {
                    font-size: 12.5px;
                    opacity: 0.9;
                    margin: 2px 0 0;
                }
                .pobill-badge {
                    background: rgba(255,255,255,0.2);
                    padding: 5px 12px;
                    border-radius: 999px;
                    font-size: 12px;
                    font-weight: 600;
                    white-space: nowrap;
                }
                .pobill-body {
                    padding: 22px 24px;
                }
                .pobill-info-grid {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 14px 24px;
                    margin-bottom: 18px;
                }
                .pobill-info-item {
                    display: flex;
                    flex-direction: column;
                    gap: 3px;
                }
                .pobill-info-item.full-width {
                    grid-column: 1 / -1;
                }
                .pobill-info-label {
                    font-size: 11.5px;
                    font-weight: 600;
                    color: #94a3b8;
                    text-transform: uppercase;
                    letter-spacing: 0.4px;
                }
                .pobill-info-value {
                    font-size: 14px;
                    color: #1f2937;
                    font-weight: 600;
                }
                .pobill-section-title {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    font-size: 13px;
                    font-weight: 700;
                    color: #475569;
                    margin: 18px 0 10px;
                    text-transform: uppercase;
                    letter-spacing: 0.4px;
                }
                .pobill-amount-card {
                    background: #f8fafc;
                    border: 1px solid #e5e7eb;
                    border-radius: 12px;
                    padding: 14px 18px;
                }
                .pobill-amount-row {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 7px 0;
                    font-size: 13.5px;
                    color: #475569;
                }
                .pobill-amount-row:not(:last-child) {
                    border-bottom: 1px dashed #e2e8f0;
                }
                .pobill-amount-row.total {
                    font-weight: 700;
                    color: #1f2937;
                    font-size: 15px;
                    padding-top: 10px;
                }
                .pobill-bank-grid {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 12px 24px;
                    background: #f8fafc;
                    border: 1px solid #e5e7eb;
                    border-radius: 12px;
                    padding: 14px 18px;
                }
                .pobill-footer-note {
                    text-align: center;
                    font-size: 11px;
                    color: #94a3b8;
                    margin-top: 20px;
                    padding-top: 14px;
                    border-top: 1px dashed #e2e8f0;
                }
                .pobill-print-btn {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    background: #1f2937;
                    color: white;
                    border: none;
                    border-radius: 10px;
                    padding: 10px 20px;
                    font-size: 13.5px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: opacity 0.15s ease;
                }
                .pobill-print-btn:hover {
                    opacity: 0.9;
                }
                @media print {
                    .pobill-card {
                        border: none;
                    }
                    .pobill-card-header {
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                }
            `}</style>

            <button title="View Bill" style={{ backgroundColor: "#00000075" }} className="model-delete-button-modern actionn-icon" onClick={handleShow}>
                <ReceiptIndianRupeeIcon size={20} color="white" />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="lg">
                <Modal.Header className="modern-modal-header">
                    <div className="header-content">
                        <div style={{ color: "white" }}>
                            <ReceiptIndianRupeeIcon size={24} />
                        </div>
                        <div>
                            <Modal.Title>Site Office Rent Bill</Modal.Title>
                            <p className="header-subtitle" style={{ color: "white" }}>{i.project_short_name}</p>
                        </div>
                    </div>
                    <button className="close-btn" onClick={handleClose}>
                        <X size={20} />
                    </button>
                </Modal.Header>

                <Modal.Body className="modern-modal-body">
                    <div ref={ref}>
                        <div className="pobill-card">
                            <div className="pobill-card-header">
                                <div>
                                    <h3 className="pobill-card-header-title">{i.project_short_name}</h3>
                                    <p className="pobill-card-header-sub">Office Rent Billing Slip</p>
                                </div>
                                <span className="pobill-badge">{getMonthName(i.month)} {i.year}</span>
                            </div>

                            <div className="pobill-body">
                                <div className="pobill-info-grid">
                                    <div className="pobill-info-item">
                                        <span className="pobill-info-label">Project Name</span>
                                        <span className="pobill-info-value">{i.project_short_name}</span>
                                    </div>
                                    <div className="pobill-info-item">
                                        <span className="pobill-info-label">From</span>
                                        <span className="pobill-info-value">{i.owner_name}</span>
                                    </div>
                                    <div className="pobill-info-item">
                                        <span className="pobill-info-label">Days</span>
                                        <span className="pobill-info-value">{i.days}</span>
                                    </div>
                                    <div className="pobill-info-item">
                                        <span className="pobill-info-label">Month / Year</span>
                                        <span className="pobill-info-value">{getMonthName(i.month)} - {i.year}</span>
                                    </div>
                                    <div className="pobill-info-item full-width">
                                        <span className="pobill-info-label">Reg</span>
                                        <span className="pobill-info-value" style={{ fontWeight: 500 }}>
                                            {`Submission of Bill against Site Office ${i.project_short_name} Rent for Month of ${getMonthName(i.month)} - ${i.year}`}
                                        </span>
                                    </div>
                                </div>

                                <div className="pobill-section-title">
                                    <Wallet size={14} /> Office Rent Amount
                                </div>
                                <div className="pobill-amount-card">
                                    <div className="pobill-amount-row">
                                        <span>Basic Amount</span>
                                        <span>{formatCurrencyIndian(i.rent_amt || 0)}</span>
                                    </div>
                                    <div className="pobill-amount-row">
                                        <span>TDS ({i.tds_percentage}%)</span>
                                        <span>{formatCurrencyIndian(i.tds_amt || 0)}</span>
                                    </div>
                                    <div className="pobill-amount-row total">
                                        <span>Total Amount</span>
                                        <span>{formatCurrencyIndian(i.total_amt || 0)}</span>
                                    </div>
                                </div>

                                <div className="pobill-section-title">
                                    <Landmark size={14} /> Bank Details
                                </div>
                                <div className="pobill-bank-grid">
                                    <div className="pobill-info-item">
                                        <span className="pobill-info-label">Account Holder</span>
                                        <span className="pobill-info-value">{i?.office_rent?.account_holder_name}</span>
                                    </div>
                                    <div className="pobill-info-item">
                                        <span className="pobill-info-label">Bank</span>
                                        <span className="pobill-info-value">{i?.office_rent?.bank_name}</span>
                                    </div>
                                    <div className="pobill-info-item">
                                        <span className="pobill-info-label">Account No.</span>
                                        <span className="pobill-info-value">{i?.office_rent?.account_num}</span>
                                    </div>
                                    <div className="pobill-info-item">
                                        <span className="pobill-info-label">IFSC Code</span>
                                        <span className="pobill-info-value">{i?.office_rent?.ifsc_code}</span>
                                    </div>
                                </div>

                                <p className="pobill-footer-note">
                                    *This is a software generated Expense Slip, no signature required*
                                </p>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <div className="form-actions hide-on-print" style={{ padding: '16px 24px' }}>
                    <ReactToPrint
                        bodyClass="print-agreement"
                        content={() => ref.current}
                        trigger={() => (
                            <button className="pobill-print-btn">
                                <Printer size={16} /> Print
                            </button>
                        )}
                    />
                </div>
            </Modal>
        </>
    );
};

const OfficeBillingDetails = (i) => {
    const [OfficeBillingDetails, setOfficeBillingDetails] = useState([]);
    const [buffer, setBuffering] = useState(false); //buffering logic
    const { projectID } = usePermission();

    const [project, setProject] = useState(projectID ? projectID : "null");
    const [search, setSearch] = useState("")
    const [projectList, setProjectList] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [Office, setOffice] = useState("null");
    const [OfficeList, setOfficeList] = useState([]);
    const [showFilters, setShowFilters] = useState(true);
    const [expandedRow, setExpandedRow] = useState(null);


    const today = new Date();
    today.setDate(today.getDate() - 1);
    const year = today.getFullYear();
    const month = today.getMonth() + 1;

    const [filterMonth, setFilterMonth] = useState(`0${month}`);
    const [filterYear, setFilterYear] = useState(`${year}`);
    const siteRole = sessionStorage.getItem("sitemanagement_role");
    const role = sessionStorage.getItem('sitemanagement_role');

    const getProjects = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const pro = await axios.get(
                sessionStorage.getItem('sitemanagement_role') === 'AuthorityEngineer' ?
                    `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${sessionStorage.getItem('sitemanagement_emp_id')}/`
                    : sessionStorage.getItem('sitemanagement_role') === 'DataEntryOperator' ?
                        `${BASE_URL}/siteproject/projectfilterbycom_operator/${sessionStorage.getItem('sitemanagement_emp_id')}/`
                        : `${BASE_URL}/siteproject/project/`
            );
            const sortedProjects = sortProjects(pro.data, 'site_prcode');
            setProjectList(sortedProjects);

        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };
    const getOfficeBillingDetails = async () => {
        setBuffering(true);
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/filter-officerent-billing/${project}/${Office}/${filterMonth}/${filterYear}/`);
            setOfficeBillingDetails(response.data);
        }
        catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    }
    useEffect(() => {
        getOfficeBillingDetails();

    }, []);
    useEffect(() => {
        getProjects();
        getOfficeBillingDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [project, Office, filterMonth, filterYear]);

    const monthOptions = [
        { id: "01", name: "January" },
        { id: "02", name: "February" },
        { id: "03", name: "March" },
        { id: "04", name: "April" },
        { id: "05", name: "May" },
        { id: "06", name: "June" },
        { id: "07", name: "July" },
        { id: "08", name: "August" },
        { id: "09", name: "September" },
        { id: 10, name: "October" },
        { id: 11, name: "November" },
        { id: 12, name: "December" }
    ];
    const getMonthName = (monthNumber) => {
        const month = monthOptions.find(m => m.id.toString() === monthNumber);
        return month ? month.name : '';
    };

    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 20; // starting 20 years ago
    const endYear = currentYear + 20; // up to 20 years in the future
    const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);

    const getOffice = async () => {
        setBuffering(true); // Start Buffering
        try {
            const veh = await axios.get(`${BASE_URL}/siteproject/officerentbilling/`);
            setOfficeList(veh.data.office_rent_billing); // Store the array directly
        } catch (err) {
            if (err.response) {
                const errorData = err.response.data;
                if (typeof errorData.error === 'string') {
                    toast.error(`Error: ${errorData.error}`);
                } else if (typeof errorData === 'object' && errorData !== null) {
                    Object.entries(errorData).forEach(([field, messages]) => {
                        messages.forEach(message => toast.error(`"${field}": ${message}`));
                    });
                } else {
                    toast.error('Error:- Failed to Process!');
                }
            } else {
                toast.error('Error processing your request.');
            }
        } finally {
            setBuffering(false); // End Buffering
        }
    };



    useEffect(() => {
        getOffice();
    }, []);

    const navigate = useNavigate();
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split("/");
    const baseUrl = "/" + urlParts[3] + `pdfofficebilling`;
    let opener = "profile"

    const [subcompany, setSubCompany] = useState("null");
    const [subcompanyList, setSubCompanyList] = useState([]);
    const getSubCompany = async () => {
        try {
            const subcompany = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompanyList(subcompany.data)

        } catch (error) {
            console.error(error);

        }
    };
    useEffect(() => {
        getSubCompany();
    }, []);

    const openPdfofficebilling = (i) => {
        navigate(baseUrl, { state: { i, opener } });
    };

    const tableRef = useRef(null);

    const toggleRow = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };

    const showFilterBar = siteRole !== "SiteManagement";
    const hasActiveFilters =
        filterMonth !== `0${month}` ||
        filterYear !== `${year}` ||
        project !== "null" ||
        Office !== "null";

    const clearAllFilters = () => {
        setFilterMonth(`0${month}`);
        setFilterYear(`${year}`);
        setProject(projectID ? projectID : "null");
        setOffice("null");
    };

    const isAllApproved = (bill) =>
        bill.account_status_a !== "pending" &&
        bill.account_status_b !== "pending" &&
        bill.admin_approval_status_c1 !== "pending" &&
        bill.admin_approval_status_c2 !== "pending" &&
        bill.admin_approval_status_c3 !== "pending" &&
        bill.authority_approval_status !== "pending" &&
        bill.checker_approval_status !== "pending";

    return (
        <div className="progress-modern-container">
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

            {showFilters && (
                <div className="filter-bar-attractive" style={{ padding: "0px" }}>
                    <div className="filter-group-attractive" style={{ padding: "0px" }}>
                        <div className={`filter-chip ${filterMonth !== `0${month}` ? "active" : ""}`} style={{ padding: "0px" }}>
                            <Monthprefix0 filterMonth={filterMonth} setFilterMonth={setFilterMonth} cssType="modern" />

                        </div>

                        <div className={`filter-chip ${filterYear !== `${year}` ? "active" : ""}`} style={{ padding: "0px" }}>
                            <div className="filter-chip-content">
                                <YearModern filterYear={filterYear} setFilterYear={setFilterYear} cssType="modern" />

                            </div>
                        </div>
                        {
                            role !== "SiteManagement" &&
                            <div className={`filter-chip ${project !== "null" ? "active" : ""}`} style={{ paddingTop: '0px', paddingBottom: "0px" }}>
                                <div className="filter-chip-content">
                                    <Projects usedFor="filter" value="id" toggleProject={project} setToggleProject={setProject} subcompany={subcompany} />
                                </div>
                            </div>
                        }


                        <div className={`filter-chip ${Office !== "null" ? "active" : ""}`}>
                            <div><CircularGrid /></div>
                            <div className="filter-chip-content">
                                <select
                                    id="Office"
                                    name="Office"
                                    value={Office}
                                    onChange={(e) => setOffice(e.target.value)}
                                    className="modern-select"
                                    style={{ cursor: 'pointer' }}
                                >
                                    <option value="null">Select Owner</option>
                                    {OfficeList?.length > 0 ? (
                                        OfficeList
                                            .sort((a, b) => a.name?.localeCompare(b.name, 'en', { ignorePunctuation: true }))
                                            .map((o, index) => (
                                                <option key={index} value={o.id}>
                                                    {o.owner_name}
                                                </option>
                                            ))
                                    ) : (
                                        <option disabled>Loading or no offices found</option>
                                    )}
                                </select>
                            </div>
                        </div>

                        {hasActiveFilters && role === "Admin" && (
                            <button className="clear-filters-btn" onClick={clearAllFilters}>
                                <X size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            )}

            <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="stats-minimal-row">
                    <div className="stat-minimal-item">
                        <Building2 size={14} />
                        <span>Showing</span>
                        <strong>{OfficeBillingDetails?.length || 0} bills</strong>
                    </div>
                </div>

                <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
                    {showFilterBar && (
                        <button className="toggle-filters-btn" onClick={() => setShowFilters(!showFilters)}>
                            <Filter size={14} />
                            <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                            {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                        </button>
                    )}

                    {role !== "ViewAccess" && (
                        <div className="filter-actions-attractive" style={{ display: 'flex', gap: '8px' }}>
                            <DownloadOfficeBill projectList={OfficeBillingDetails} />
                            <AddMultipleOfficeRentBilling getData={getOfficeBillingDetails} />
                        </div>
                    )}
                </div>
            </div>

            <div className="table-wrapper-minimal table-box scroll-container-table">
                {buffer ? (
                    <div className="loader-minimal">
                        <div className="spinner-minimal"></div>
                    </div>
                ) : (
                    <table className="progress-table-minimal" ref={tableRef}>
                        <thead className="table-heading">
                            <tr>
                                <th className="col-sno" style={{ width: '5%' }}>#</th>
                                <th className="col-period text-center">Details</th>
                                <th className="col-submitted text-center" style={{ width: '8%' }}>Days</th>
                                <th className="col-submitted text-center" style={{ width: '12%' }}>Month</th>
                                <th className="col-submitted text-center" style={{ width: '8%' }}>Year</th>
                                <th className="col-approved text-center" style={{ width: '14%' }}>Office Rent Amount</th>
                                <th className="col-status text-center" style={{ width: '12%' }}>Status</th>
                                <th className="col-action text-center" style={{ width: '12%' }}>View Slip/Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {OfficeBillingDetails != undefined && OfficeBillingDetails.length > 0 ? (
                                OfficeBillingDetails.map((bill, index) => {
                                    const isExpanded = expandedRow === index;
                                    return (
                                        <React.Fragment key={index}>
                                            <tr className="progress-row">
                                                <td className="col-sno text-start">{index + 1}.</td>
                                                <td className="col-period">
                                                    <button className="period-trigger" style={{ width: "100%" }} onClick={() => toggleRow(index)}>
                                                        <Building2 size={12} />
                                                        <span>{bill.project_short_name} • {bill.owner_name}</span>
                                                        {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                                                    </button>
                                                    <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '4px', paddingLeft: '4px' }}>
                                                        {formatDate(bill.date)}
                                                    </div>
                                                </td>
                                                <td className="col-submitted text-center">{bill.days}</td>
                                                <td className="col-submitted text-center">{getMonthName(bill.month)}</td>
                                                <td className="col-submitted text-center">{bill.year}</td>
                                                <td className="col-approved text-center">
                                                    <span className="badge-value">₹{formatCurrencyIndian(bill.total_amt || 0)}</span>
                                                </td>
                                                <td className="col-status text-center">
                                                    <ViewDynamicApprovalStatus dynamic_approval={bill?.dynamic_approvals} />
                                                </td>
                                                <td className="col-action text-center">
                                                    <div className="action-group-minimal" style={{ justifyContent: 'center' }}>
                                                        {isAllApproved(bill) && (
                                                            <ViewPdfoffice i={bill} getOfficeBill={getOfficeBillingDetails} />
                                                        )}
                                                        {!(role === "SiteManagement" || role === "Checker") && role !== "ViewAccess" && (
                                                            <DeleteOfficeRentBill i={bill} getOfficeBill={getOfficeBillingDetails} />
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>

                                            {isExpanded && (
                                                <tr className="expanded-row">
                                                    <td colSpan={8}>
                                                        <div className="expanded-content-attractive">
                                                            <div className="expanded-content-header">
                                                                <div className="expanded-content-title">
                                                                    <Sparkles size={13} />
                                                                    <span>Billing Breakdown</span>
                                                                </div>
                                                            </div>

                                                            <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', marginBottom: '14px' }}>
                                                                <div className="stage-card submitted" style={{ flex: 1, minWidth: '240px' }}>
                                                                    <div className="stage-header">
                                                                        <Building2 size={14} />
                                                                        <span>Office Details</span>
                                                                    </div>
                                                                    <div className="stage-content">
                                                                        <div className="stage-row"><span className="stage-label">Project</span><span className="amount">{bill.project_short_name || "-"}</span></div>
                                                                        <div className="stage-row"><span className="stage-label">Owner Name</span><span className="amount">{bill.owner_name || "-"}</span></div>
                                                                        <div className="stage-row"><span className="stage-label">Date</span><span className="amount">{formatDate(bill.date) || "-"}</span></div>
                                                                    </div>
                                                                </div>

                                                                <div className="stage-card approved" style={{ flex: 1, minWidth: '240px' }}>
                                                                    <div className="stage-header">
                                                                        <Wallet size={14} />
                                                                        <span>Amount Details</span>
                                                                    </div>
                                                                    <div className="stage-content">
                                                                        <div className="stage-row"><span className="stage-label">Basic Amount</span><span className="amount">₹{formatCurrencyIndian(bill.rent_amt || 0)}</span></div>
                                                                        <div className="stage-row"><span className="stage-label">TDS</span><span className="amount">₹{formatCurrencyIndian(bill.tds_amt || 0)} ({bill.tds_percentage}%)</span></div>
                                                                        <div className="stage-row"><span className="stage-label">Total Amount</span><span className="amount" style={{ fontWeight: 700 }}>₹{formatCurrencyIndian(bill.total_amt || 0)}</span></div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="stage-card" style={{ background: 'white' }}>
                                                                <div className="stage-header">
                                                                    <FileText size={14} />
                                                                    <span>Remarks</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <ViewDynamicApprovalRemarks dynamic_approval={bill?.dynamic_approvals} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={8}>
                                        <div className="empty-state-attractive">
                                            <div className="empty-state-icon-wrap">
                                                <Building2 size={32} />
                                            </div>
                                            <h4 className="empty-state-title">No Office Billing Records Found</h4>
                                            <p className="empty-state-subtitle">
                                                Try adjusting your filters to view billing records.
                                            </p>
                                            {hasActiveFilters && role === "Admin" && (
                                                <button className="empty-state-clear-btn" onClick={clearAllFilters}>
                                                    <X size={13} />
                                                    Clear Filters
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    )

}

export default OfficeBillingDetails;